import React, { ReactNode } from 'react';
import { RequirementType, validationMap } from '../../../../network/api/types/compte/RequirementType';

type RequirementProps = {
  children: ReactNode;
  type: RequirementType;
  value: string;
};

function Requirement({ children, type, value }: RequirementProps): JSX.Element {
  const isValid = validationMap[type](value);

  return (
    <div className={`rule ${isValid ? 'correct' : ''}`}>
      <i className={`${isValid ? 'fa fa-check' : 'fa fa-circle'}`} />
      {children}
    </div>
  );
}

export default Requirement;
